module.exports = __webpack_public_path__ + "files/van-der-mee-valentin.fe222b9c7831fdfc0547435fc7d07d19.pdf";